import { MEDIA_ENTRY_FOLDER } from "fleet/constant/media-library";
import { MediaTableController } from "fleet/controller/media-library/media-table-controller";
import { PropTypeMediaFilterFields } from "fleet/prop-types";
import { folderContentsToSpots } from "fleet/view/media-library/utils";
import { PropTypePriorities } from "fleet/view/strategy-v2/utils";
import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import { getById } from "redux-store";
import { Column } from "ui/table";

class AddSpotMediaTableController extends React.PureComponent {
  static get propTypes() {
    const mtcPropTypes = MediaTableController.propTypes;

    return {
      ...{
        excludeColumns: mtcPropTypes.excludeColumns,
        includeMediaTypes: mtcPropTypes.includeMediaTypes,
      },
      addSpots: PropTypes.func,
      applications: PropTypes.object,
      contentFolders: PropTypes.object,
      contentGroups: PropTypes.object,
      filterFields: PropTypes.arrayOf(PropTypeMediaFilterFields),
      priority: PropTypePriorities.isRequired,
      userContents: PropTypes.object,
    };
  }

  static get defaultProps() {
    return {
      addSpots: () => {},
      applications: {},
      contentFolders: {},
      contentGroups: {},
      excludeColumns: MediaTableController.defaultProps.excludeColumns,
      includeMediaTypes: [],
      userContents: {},
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      highlight: null,
    };

    this.timer = null;

    this._formatActions = this._formatActions.bind(this);
  }

  _getSpotsFromFolder(mediaEntry) {
    const { id } = mediaEntry;
    const { applications, contentFolders, contentGroups, userContents } =
      this.props;
    const folder = getById(contentFolders, id);

    return folderContentsToSpots(
      applications,
      userContents,
      contentGroups,
      folder,
    );
  }

  _addSpots(mediaEntry, index) {
    const { priority, addSpots } = this.props;
    const { type } = mediaEntry;

    const spots =
      type === MEDIA_ENTRY_FOLDER
        ? this._getSpotsFromFolder(mediaEntry)
        : [mediaEntry];

    const payload = {
      priority,
      spots,
    };

    addSpots(payload);

    this.setState(
      {
        highlight: index,
      },
      () => {
        if (this.timer) {
          clearTimeout(this.timer);
        }

        this.timer = setTimeout(() => {
          this.setState({ highlight: null });
          this.timer = null;
        }, 1000);
      },
    );
  }

  _formatActions(_, mediaEntry, enumObject, index) {
    const { type } = mediaEntry;
    const title =
      type === MEDIA_ENTRY_FOLDER
        ? // eslint-disable-next-line quotes
          "Add all of this folder's contents to the strategy"
        : "Add this spot to the strategy";

    return (
      <div className="content-table-actions">
        <Button
          variant="success"
          className="add-content"
          title={title}
          onClick={this._addSpots.bind(this, mediaEntry, index)}
        >
          <i className="fa fa-plus" aria-hidden="true" />
          {" Add"}
        </Button>
      </div>
    );
  }

  _renderActionsColumn() {
    return (
      <Column
        dataField="actions"
        dataFormat={this._formatActions}
        key="actions"
        width="170px"
      >
        Actions
      </Column>
    );
  }

  filterTableData(data) {
    return data.filter((entry) => !entry.archived);
  }

  render() {
    const { highlight } = this.state;
    const {
      applications,
      contentFolders,
      contentGroups,
      excludeColumns,
      filterFields,
      includeMediaTypes,
      userContents,
    } = this.props;

    return (
      <MediaTableController
        applications={applications}
        contentFolders={contentFolders}
        contentGroups={contentGroups}
        excludeColumns={excludeColumns}
        extraColumns={this._renderActionsColumn()}
        filterFields={filterFields}
        highlight={highlight}
        includeMediaTypes={includeMediaTypes}
        processTableData={this.filterTableData}
        userContents={userContents}
      />
    );
  }
}

export { AddSpotMediaTableController };
